import React from 'react';
import { Link } from 'react-router-dom';
import LessonIcon from '../../components/LessonIcon';
import { MultipartLessonSection } from '../../types';

type Props = {
    section: MultipartLessonSection,
};

// TODO: Wo sollen bei Videos Überschrift und Länge angezeigt werden?

export default ({ section }: Props) => (
    <section className="exersises-list">
        {section.title && (<h4>{section.title}</h4>)}
        <div
            className="category-list grid row justify-content-center"
            style={{
                backgroundColor: section.layout.color.bgColor,
                color: section.layout.color.fontColor,
            }}
        >
            {section.lessons.map(lesson => (
                <div className="col-12 col-lg-4" key={lesson.id}>
                    <Link
                        to={lesson.link}
                    >
                        <div className="mental-icon">
                            {(lesson.iconUrl) ? (
                                <LessonIcon
                                    iconType={lesson.iconType}
                                    iconUrl={lesson.iconUrl}
                                    multipart
                                />
                            ) : (
                                <div
                                    className="mental-multipart-icon"
                                    style={{
                                        backgroundColor: lesson.iconColor,
                                        color: lesson.iconFontColor,
                                    }}
                                >
                                    <span>{lesson.title}</span>
                                    {lesson.length && (<small>{lesson.length}</small>)}
                                </div>
                            )}
                        </div>
                        {lesson.type === 'video' ? (<div className="mental-name">{lesson.title}</div>) : null}
                    </Link>
                </div>
            ))}
        </div>
    </section>
);
